export default __webpack_public_path__ + "static/media/lsmt-logo.c63998d7.webp";